"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParentFilterTitles = exports.showItemsFilteredMessage = exports.showAllFilteredMessage = exports.getFilterAttributeTitle = exports.attributeElementsToAttributeElementArray = exports.isParentFilteringEnabled = exports.isParentFiltersElementsByRef = exports.getValidElementsFilters = exports.getObjRef = exports.getElements = exports.needsLoading = exports.getElementTotalCount = exports.updateSelectedOptionsWithData = exports.updateSelectedOptionsWithDataByMap = exports.getItemsTitles = exports.getNoneTitleIntl = exports.getFilteringTitleIntl = exports.getLoadingTitleIntl = exports.getAllExceptTitle = exports.getAllTitle = exports.getAllTitleIntl = void 0;
var tslib_1 = require("tslib");
var isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
var types_1 = require("../AttributeDropdown/types");
var sdk_model_1 = require("@gooddata/sdk-model");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
exports.getAllTitleIntl = function (intl, isInverted, empty, equal) {
    if ((isInverted && empty) || (!isInverted && equal)) {
        return exports.getAllTitle(intl);
    }
    return exports.getAllExceptTitle(intl);
};
exports.getAllTitle = function (intl) {
    return intl.formatMessage({ id: "attrf.all" });
};
exports.getAllExceptTitle = function (intl) {
    return intl.formatMessage({ id: "attrf.all_except" });
};
exports.getLoadingTitleIntl = function (intl) {
    return intl.formatMessage({ id: "loading" });
};
exports.getFilteringTitleIntl = function (intl) {
    return intl.formatMessage({ id: "filtering" });
};
exports.getNoneTitleIntl = function (intl) {
    return intl.formatMessage({ id: "gs.filterLabel.none" });
};
exports.getItemsTitles = function (selectedFilterOptions, elementTitles, isElementsByRef) {
    return selectedFilterOptions
        .map(function (selectedOption) {
        var _a;
        var key = isElementsByRef ? selectedOption.uri : selectedOption.title;
        return key
            ? (_a = elementTitles.get(key)) === null || _a === void 0 ? void 0 : _a.title : (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.title) ? selectedOption.title
            : undefined;
    })
        .filter(function (title) { return !isEmpty_1.default(title); })
        .join(", ");
};
exports.updateSelectedOptionsWithDataByMap = function (selection, validElements, isElementsByRef) {
    return selection.map(function (selectedItem) {
        var key = isElementsByRef ? selectedItem.uri : selectedItem.title;
        return validElements.get(key);
    });
};
exports.updateSelectedOptionsWithData = function (selection, items) {
    /**
     * For original AttributeFilter we need to handle empty `items` property as a indicator, that items
     * should not be changed and should be extended by the missing `uri` or `title` property (if needed)
     * so it can be used in AttributeFilterDropdown.
     *
     * This won't affect `AttributeFilterButton` component in any case.
     */
    if (isEmpty_1.default(items)) {
        return selection.map(function (item) {
            var _a, _b;
            return {
                title: (_a = item === null || item === void 0 ? void 0 : item.title) !== null && _a !== void 0 ? _a : "",
                uri: (_b = item === null || item === void 0 ? void 0 : item.uri) !== null && _b !== void 0 ? _b : "",
            };
        });
    }
    var createFullItem = function (item) {
        var _a, _b;
        return ({
            uri: (_a = item.uri) !== null && _a !== void 0 ? _a : "",
            title: (_b = item.title) !== null && _b !== void 0 ? _b : "",
        });
    };
    var nonEmptyItems = items.filter(types_1.isNonEmptyListItem);
    return selection.map(function (selectedItem) {
        return (nonEmptyItems.find(function (item) {
            return ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.uri) && item.uri === selectedItem.uri) ||
                ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title) && item.title === selectedItem.title);
        }) || createFullItem(selectedItem));
    });
};
exports.getElementTotalCount = function (workspace, backend, objRef, searchString, parentFilters) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var elementsLoader, elements;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                elementsLoader = backend
                    .workspace(workspace)
                    .attributes()
                    .elements()
                    .forDisplayForm(objRef)
                    .withOptions(tslib_1.__assign({}, (searchString ? { filter: searchString } : {})));
                // only set the parent filters if needed to avoid errors on backends that do not support this feature
                if ((parentFilters === null || parentFilters === void 0 ? void 0 : parentFilters.length) > 0 && exports.isParentFilteringEnabled(backend)) {
                    elementsLoader = elementsLoader.withAttributeFilters(parentFilters);
                }
                return [4 /*yield*/, elementsLoader.query()];
            case 1:
                elements = _a.sent();
                return [2 /*return*/, elements.totalCount];
        }
    });
}); };
function needsLoading(validElements, offset, limit) {
    var currentElements = validElements ? validElements.items : [];
    var isQueryOutOfBound = offset + limit > currentElements.length;
    var isMissingDataInWindow = currentElements
        .slice(offset, offset + limit)
        .some(function (e) { return e.empty; });
    var hasAllData = validElements &&
        currentElements.length === validElements.totalCount &&
        !currentElements.some(function (e) { return e.empty; });
    return !hasAllData && (isQueryOutOfBound || isMissingDataInWindow);
}
exports.needsLoading = needsLoading;
exports.getElements = function (validElements, offset, limit, loadElements, force) {
    if (force === void 0) { force = false; }
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (needsLoading(validElements, offset, limit) || force) {
                return [2 /*return*/, loadElements(offset, limit)];
            }
            return [2 /*return*/, {
                    validOptions: validElements,
                    totalCount: validElements.totalCount,
                }];
        });
    });
};
exports.getObjRef = function (filter, identifier) {
    if (filter && identifier) {
        throw new Error("Don't use both identifier and filter to specify the attribute to filter");
    }
    if (filter) {
        return sdk_model_1.filterObjRef(filter);
    }
    if (identifier) {
        // eslint-disable-next-line no-console
        console.warn("Definition of an attribute using 'identifier' is deprecated, use 'filter' property instead. Please see the documentation of [AttributeFilter component](https://sdk.gooddata.com/gooddata-ui/docs/attribute_filter_component.html) for further details.");
        return sdk_model_1.idRef(identifier);
    }
};
exports.getValidElementsFilters = function (parentFilters, overAttribute) {
    if (!parentFilters || !overAttribute) {
        return [];
    }
    var overAttributeGetter = isFunction_1.default(overAttribute) ? overAttribute : function () { return overAttribute; };
    return parentFilters
        .filter(function (parentFilter) {
        return (!sdk_model_1.filterIsEmpty(parentFilter) &&
            sdk_model_1.isAttributeElementsByRef(sdk_model_1.filterAttributeElements(parentFilter)));
    })
        .map(function (attributeFilter, index) {
        return {
            attributeFilter: attributeFilter,
            overAttribute: overAttributeGetter(attributeFilter, index),
        };
    });
};
exports.isParentFiltersElementsByRef = function (parentFilters) {
    return parentFilters === null || parentFilters === void 0 ? void 0 : parentFilters.every(function (parentFilter) {
        return sdk_model_1.isAttributeElementsByRef(sdk_model_1.filterAttributeElements(parentFilter));
    });
};
exports.isParentFilteringEnabled = function (backend) {
    return !!backend.capabilities.supportsElementsQueryParentFiltering;
};
function attributeElementsToAttributeElementArray(elements) {
    if (sdk_model_1.isAttributeElementsByValue(elements)) {
        return elements.values.map(function (title) { return ({
            title: title,
        }); });
    }
    else if (sdk_model_1.isAttributeElementsByRef(elements)) {
        return elements.uris.map(function (uri) { return ({
            uri: uri,
        }); });
    }
    return [];
}
exports.attributeElementsToAttributeElementArray = attributeElementsToAttributeElementArray;
function getFilterAttributeTitle(backend, workspace, filter) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var attributes, displayForm, attribute;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    attributes = backend.workspace(workspace).attributes();
                    return [4 /*yield*/, attributes.getAttributeDisplayForm(exports.getObjRef(filter, null))];
                case 1:
                    displayForm = _a.sent();
                    return [4 /*yield*/, attributes.getAttribute(displayForm.attribute)];
                case 2:
                    attribute = _a.sent();
                    return [2 /*return*/, attribute.title];
            }
        });
    });
}
exports.getFilterAttributeTitle = getFilterAttributeTitle;
function showAllFilteredMessage(isElementsLoading, parentFilters, totalElementsCount) {
    if (!parentFilters) {
        return false;
    }
    var parentFiltersEmpty = parentFilters.every(function (filter) { return sdk_model_1.filterIsEmpty(filter); });
    return !isElementsLoading && !parentFiltersEmpty && totalElementsCount === 0;
}
exports.showAllFilteredMessage = showAllFilteredMessage;
function showItemsFilteredMessage(isElementsLoading, parentFilters) {
    if (!parentFilters) {
        return false;
    }
    var parentFiltersNotEmpty = parentFilters.some(function (filter) { return !sdk_model_1.filterIsEmpty(filter); });
    return !isElementsLoading && parentFiltersNotEmpty;
}
exports.showItemsFilteredMessage = showItemsFilteredMessage;
function getParentFilterTitles(filters, backend, workspace) {
    var promises = filters.map(function (parentFilter) {
        return getFilterAttributeTitle(backend, workspace, parentFilter);
    });
    return Promise.all(promises);
}
exports.getParentFilterTitles = getParentFilterTitles;
//# sourceMappingURL=AttributeFilterUtils.js.map